import { render, staticRenderFns } from "./ContactReportsReviewList.vue?vue&type=template&id=07d969f5&scoped=true"
import script from "./ContactReportsReviewList.vue?vue&type=script&lang=js"
export * from "./ContactReportsReviewList.vue?vue&type=script&lang=js"
import style0 from "./ContactReportsReviewList.vue?vue&type=style&index=0&id=07d969f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d969f5",
  null
  
)

export default component.exports